import { Table } from "@/components";
import { UserStatus } from "@/types";
import {
  formatReferralUserStatus,
  formatUserRoleToName,
  ImgSrc,
} from "@/utils";
import {
  Autorenew as PendingIcon,
  Block as RejectIcon,
  CheckCircleOutline as SuccessIcon,
} from "@mui/icons-material";
import { Avatar, Stack, Typography } from "@mui/material";
import { green, red, yellow } from "@mui/material/colors";
import { FC, useState } from "react";
import { Loading } from "react-admin";
import { useParams } from "react-router-dom";
import { useGetReferralInvites } from "../../queries";

const ROWS_PER_PAGE = 5;

const ReferralInvites: FC = () => {
  const { id } = useParams();
  const [page, setPage] = useState(0);

  const { invites, isReferralInvitesLoading, fetchNextPage } =
    useGetReferralInvites({
      page,
      referralId: id,
      perPage: ROWS_PER_PAGE,
    });

  if (!invites) {
    return null;
  }
  if (isReferralInvitesLoading) {
    return <Loading />;
  }

  const onPageChange = async (newPage: number) => {
    await fetchNextPage();
    setPage(newPage);
  };

  return (
    <Stack width={"100%"}>
      <Typography variant="h6" gutterBottom>
        Invites
      </Typography>

      {invites.meta.total ? (
        <Table
          page={page}
          rowsPerPage={ROWS_PER_PAGE}
          rowsPerPageOptions={[]}
          headCells={["Name", "Role", "Status"]}
          count={invites.meta.total}
          onPageChange={onPageChange}
          bodyCells={invites.data.map(
            ({ firstName, lastName, profileImage, role, status }) => [
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Avatar
                  alt="avatar"
                  src={ImgSrc(profileImage?.path ?? "")}
                  sx={{ height: 32, width: 32 }}
                />
                <Typography variant="body2">{`${firstName} ${lastName}`}</Typography>
              </Stack>,
              formatUserRoleToName(role),
              <Stack direction={"row"} alignItems={"center"} spacing={0.5}>
                {status === UserStatus.ACTIVE && (
                  <SuccessIcon fontSize="small" sx={{ color: green[500] }} />
                )}
                {status === UserStatus.PENDING && (
                  <PendingIcon fontSize="small" sx={{ color: yellow[500] }} />
                )}
                {status !== UserStatus.PENDING &&
                  status !== UserStatus.ACTIVE && (
                    <RejectIcon fontSize="small" sx={{ color: red[500] }} />
                  )}
                <Typography variant="body2">
                  {formatReferralUserStatus(status)}
                </Typography>
              </Stack>,
            ]
          )}
        />
      ) : (
        <Typography>No data</Typography>
      )}
    </Stack>
  );
};

export { ReferralInvites };
